import React, { useEffect } from "react";
import {
  Link,
  useLoaderData,
  useNavigate
} from "react-router-dom";
import * as API from "../services/psqi";
import PsqiCardResults from "./PsqiCardResults";

import { psqiCardData } from "./PsqiCardData";

import { calculatePsqiResults } from "./PsqiCalc";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  const result = await API.getAllPsqiByTax(params.tratamientoId);
  const filteredResult = result.filter(item => Object.keys(item).length !== 0);
  console.log(filteredResult);
  return filteredResult;
}

export function PsqiComparativaItem(props) {
  const psqiList = useLoaderData();
  const navigate = useNavigate();

  const transformPsqiData = (psqiData) => {
    return psqiData
      .map(psqi => {
        // Llama a calculatePsqiResults para obtener los cálculos
        const results = calculatePsqiResults(psqi.meta);

        // Formatear la fecha a dd/mm/aaaa
        const rawFecha = psqi.meta?.metaFecha;
        const [year, month, day] = rawFecha.split("-");
        const fecha = `${day}/${month}/${year}`;

        return {
          ...results,
          fecha,
        };
      })
      .sort((a, b) => {
        const dateA = new Date(a.fecha.split('/').reverse().join('-'));
        const dateB = new Date(b.fecha.split('/').reverse().join('-'));
        return dateA - dateB;  // Ordena de más antiguo a más reciente
      });
  };

  const transformedPsqiList = transformPsqiData(psqiList);
  console.log('Datos filtrados para gráficos:', transformedPsqiList);

  const renderEmptyMessage = () => {
    if (psqiList.length === 0) {
      return <h1>Aquí podrás ver la evolución de tus resultados. Actualmente no existen datos para comparar.</h1>;
    }

    if (transformedPsqiList.length === 0) {
      return <h1>No hay suficientes respuestas para mostrar los gráficos. Por favor, completa más cuestionarios.</h1>;
    }

    return null;
  };

  useEffect(() => {
    if (psqiList.length === 1 && props.userRole.includes("paciente")) {
      const objectId = psqiList[0].id; // Obtén el ID del único objeto
      navigate(`${objectId}`); // Navega a la URL con el ID
    }
  }, [psqiList, navigate, props.userRole]);

  return (
    <>
      <div id="content" className='comparativa-graficas-container'>
        {renderEmptyMessage() || (
          <form className="analitic-form">
            <h3>{ props.userRole.includes("paciente") ? "Sueño" : "Cuestionario PSQI" }</h3>
            <div className="five-col-analitic">
              {psqiCardData.map((psqiData, index) => (
                <PsqiCardResults 
                  key={index}
                  title={psqiData.title}
                  data={transformedPsqiList}
                  dataKey={psqiData.dataKey}
                />
              ))}
            </div>
          </form>
        )}
      </div>
      <div id="actions">
        {!props.userRole.includes("paciente") && (
          <Link className="button is-link" to={`new`}>Nuevo</Link>
        )}
      </div>
    </>
  );
}
